import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setEtco2TypeOptions } from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { ITempMethodResponse } from '../../vitals/store/vitals.types'

export function* getEtco2TypeOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const etco2TypeOptions: ITempMethodResponse = yield call([vitalsService, vitalsService.getEtco2])
    const { entity } = etco2TypeOptions
    yield put(setEtco2TypeOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getEtco2() error: ${e}`))
  }
}

export function* getEtco2TypeOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getEtco2TypeOptions)
}
